export default [
  {
    state: 'Acre',
    state_abbr: 'AC',
    capital: 'Rio Branco',
    postal_code: '69900970'
  },
  {
    state: 'Alagoas',
    state_abbr: 'AL',
    capital: 'Maceió',
    postal_code: '57020970'
  },
  {
    state: 'Amapá',
    state_abbr: 'AP',
    capital: 'Macapá',
    postal_code: '68906974'
  },
  {
    state: 'Amazonas',
    state_abbr: 'AM',
    capital: 'Manaus',
    postal_code: '69010970'
  },
  {
    state: 'Bahia',
    state_abbr: 'BA',
    capital: 'Salvador',
    postal_code: '40015970'
  },
  {
    state: 'Ceará',
    state_abbr: 'CE',
    capital: 'Fortaleza',
    postal_code: '60030970'
  },
  {
    state: 'Distrito Federal',
    state_abbr: 'DF',
    capital: 'Brasília',
    postal_code: '71950970'
  },
  {
    state: 'Espírito Santo',
    state_abbr: 'ES',
    capital: 'Vitória',
    postal_code: '29001970'
  },
  {
    state: 'Goiás',
    state_abbr: 'GO',
    capital: 'Goiânia',
    postal_code: '74001970'
  },
  {
    state: 'Maranhão',
    state_abbr: 'MA',
    capital: 'São Luís',
    postal_code: '65010970'
  },
  {
    state: 'Mato Grosso',
    state_abbr: 'MT',
    capital: 'Cuiabá',
    postal_code: '78005970'
  },
  {
    state: 'Mato Grosso do Sul',
    state_abbr: 'MS',
    capital: 'Campo Grande',
    postal_code: '79125970'
  },
  {
    state: 'Minas Gerais',
    state_abbr: 'MG',
    capital: 'Belo Horizonte',
    postal_code: '30161970'
  },
  {
    state: 'Pará',
    state_abbr: 'PA',
    capital: 'Belém',
    postal_code: '66017970'
  },
  {
    state: 'Paraíba',
    state_abbr: 'PB',
    capital: 'João Pessoa',
    postal_code: '58010970'
  },
  {
    state: 'Paraná',
    state_abbr: 'PR',
    capital: 'Curitiba',
    postal_code: '80001970'
  },
  {
    state: 'Pernambuco',
    state_abbr: 'PE',
    capital: 'Recife',
    postal_code: '50010970'
  },
  {
    state: 'Piauí',
    state_abbr: 'PI',
    capital: 'Teresina',
    postal_code: '64001970'
  },
  {
    state: 'Rio de Janeiro',
    state_abbr: 'RJ',
    capital: 'Rio de Janeiro',
    postal_code: '20221970'
  },
  {
    state: 'Rio Grande do Norte',
    state_abbr: 'RN',
    capital: 'Natal',
    postal_code: '59010970'
  },
  {
    state: 'Rio Grande do Sul',
    state_abbr: 'RS',
    capital: 'Porto Alegre',
    postal_code: '90001970'
  },
  {
    state: 'Rondônia',
    state_abbr: 'RO',
    capital: 'Porto Velho',
    postal_code: '76801974'
  },
  {
    state: 'Roraima',
    state_abbr: 'RR',
    capital: 'Boa Vista',
    postal_code: '69301970'
  },
  {
    state: 'Santa Catarina',
    state_abbr: 'SC',
    capital: 'Florianópolis',
    postal_code: '88010970'
  },
  {
    state: 'São Paulo',
    state_abbr: 'SP',
    capital: 'São Paulo',
    postal_code: '01031970'
  },
  {
    state: 'Sergipe',
    state_abbr: 'SE',
    capital: 'Aracaju',
    postal_code: '49010970'
  },
  {
    state: 'Tocantins',
    state_abbr: 'TO',
    capital: 'Palmas',
    postal_code: '77064592'
  }
];
